const employeeDisplayPreferences = {
    employeeDisplayPreferences: {
        employeeDisplayOrganizationalPathLength: 0,
    },
};

const employeesArchiveSettings = {
    employeesArchiveSettings: {
        isEmployeesArchiveHidden: false,
        isEmployeesAutoArchiveOnCancelledBidEnabled: false,
        employeesCancelledBidAutoArchiveNumberOfDays: 0,
        isEmployeesAutoArchiveOnSignedOffBidEnabled: false,
        employeesSignedOffBidAutoArchiveNumberOfDays: 0
    },
};

const managersArchiveSettings = {
    managersArchiveSettings: {
        isManagersAutoArchiveOnCancelledBidEnabled: false,
        managersCancelledBidAutoArchiveNumberOfDays: 0,
        isManagersAutoArchiveOnSignedOffBidEnabled: false,
        managersSignedOffBidAutoArchiveNumberOfDays: 0
    },
};

/** @type {GlobalSetup.GlobalSetupAppData} */
const globalSetupInitialState = {
    isGlobalSetupDataLoaded: false,
    ...employeeDisplayPreferences,
    ...employeesArchiveSettings,
    ...managersArchiveSettings,
    reset: { ...employeeDisplayPreferences, ...employeesArchiveSettings, ...managersArchiveSettings },
};

export default globalSetupInitialState;
